import { FC } from 'react';
import {
  FormControl,
  FormLabel,
  Input,
  Stack,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
  Modal,
  Text,
} from '@chakra-ui/react';
import { useDeleteStore } from '../../hooks';

type Props = ReturnType<typeof useDeleteStore>;

export const CrawlerDeleteModalView: FC<Props> = ({
  values,
  isOpenModal,
  onCloseModal,
  onDeleteCrawler,
}) => (
  <Modal
    isOpen={isOpenModal}
    onClose={onCloseModal}
    size="2xl"
    blockScrollOnMount
  >
    <ModalOverlay />
    <ModalContent>
      <ModalHeader p="40px">クローラーの削除</ModalHeader>
      <ModalCloseButton />
      <ModalBody px="40px">
        <Stack spacing="6" direction="column">
          <FormControl>
            <FormLabel>クローラーID</FormLabel>
            <Input
              type="text"
              value={values.id}
              width="240px"
              variant="flushed"
              isReadOnly
              isTruncated
            />
          </FormControl>
          <FormControl>
            <FormLabel>クローラー名</FormLabel>
            <Input
              type="text"
              value={values.name}
              variant="flushed"
              isReadOnly
              isTruncated
            />
          </FormControl>
          <FormControl>
            <FormLabel>イメージ名</FormLabel>
            <Input
              type="text"
              value={values.imageName}
              variant="flushed"
              isReadOnly
              isTruncated
            />
          </FormControl>
        </Stack>
        <Text mt="60px" align="center" fontWeight="bold">
          上記のクローラー情報を削除しますか？
        </Text>
      </ModalBody>
      <ModalFooter gap="16px" justifyContent="center" p="40px">
        <Button
          w="140px"
          colorScheme="blackAlpha"
          variant="outline"
          onClick={onCloseModal}
        >
          キャンセル
        </Button>
        <Button colorScheme="red" onClick={onDeleteCrawler} w="140px">
          削除
        </Button>
      </ModalFooter>
    </ModalContent>
  </Modal>
);
